import { render, staticRenderFns } from "./Nomination.vue?vue&type=template&id=16cb0f2f&"
import script from "./Nomination.vue?vue&type=script&lang=js&"
export * from "./Nomination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports